import React from 'react';
import { createFileRoute } from '@tanstack/react-router';

import Report from '@pages/report/ui/PageReport';

export const Route = createFileRoute('/_auth/_layout/report')({
  component: () => <Report />,
});
